export enum AuthOnFileRpaErrorType {
  REGIMEN_NOT_FOUND = "regimen_not_found",
  BUSINESS_OFFICE_ROWS_NOT_FOUND = "business_office_rows_not_found",
  VISIT_DATE_CONTENT_NOT_FOUND = "visit_date_content_not_found",
}
